import { EnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';

/**
 * Where the host apps serve the files pdf.js loads over the network. Left alone, `ng2-pdf-viewer` takes the worker
 * from cdn.jsdelivr.net and the character maps from unpkg.com, so every recipient of a public document link fetches
 * them from a domain we do not control. Both are copied from the `pdfjs-dist` nested inside `ng2-pdf-viewer` — the
 * version its bundled API was built against, which the worker has to match — by the `assets` entries in each host
 * app's `project.json`.
 *
 * This is an entry point of its own so an app can register the worker without pulling `pdf-viewer` — and with it the
 * whole of ng2-pdf-viewer — out of its lazy chunk and into the initial bundle.
 */
export const PDFJS_ASSETS_PATH = '/assets/pdfjs';

/** Also keeps `ng2-pdf-viewer` on the parameter branch that disables `eval` (CVE-2024-4367); blanking it re-enables it. */
export const PDFJS_CMAPS_URL = `${PDFJS_ASSETS_PATH}/cmaps/`;

/**
 * `PdfViewerComponent` reads the worker url in its constructor and falls back to a CDN when it is unset, so it is
 * assigned at bootstrap, before any viewer exists. Every app whose `project.json` copies the assets registers this.
 */
export function providePdfjsSelfHostedAssets(): EnvironmentProviders {
  return provideEnvironmentInitializer(() => {
    (globalThis as { pdfWorkerSrc?: string }).pdfWorkerSrc = `${PDFJS_ASSETS_PATH}/pdf.worker.min.mjs`;
  });
}
